var page = {
	
	// Page Trackers
	tracking: {
		current: 'preloader',
		previous: '',
	},

	navbarOpen: false,
	
	chooseLanding:function(){
		
		//Check for query string
		if (window.location.hash.length === 0) {
			
			//If none load landing page
			page.change('landing');
			
		//If yes 
		} else {
			
			querystring = window.location.hash.replace('#', '');
			
			//get the recieved page
			page.change('recieved');
			
			// Process the message
			app.recieveMessage(querystring);
		}
	},
	
	change:function(newPage){
		//Update the pages index
		page.tracking.previous = page.tracking.current;
		page.tracking.current = newPage;
		
		$('.js-page').removeClass('is-ready');
		
		//$('.js-page, .js-page *').attr('style', '');
		
		//Toggle classes for previous page
		$('#js-pg-'+page.tracking.previous).addClass('is-previous').removeClass('is-current');
		
		//Toggle Classes for new page
		$('#js-pg-'+page.tracking.current).addClass('is-current');
		
		//appBar.setBack();
		
		if(page.tracking.current  === 'explore' ){
			if(app.createMens)app.createMens.kill();
			app.dispatcher.dispatch( EVENTS.SHOW_EXPLORE );
		}
		if(page.tracking.current  === 'share' ){
			if(app.createMens) app.createMens.kill();
			app.dispatcher.dispatch( EVENTS.SHOW_SHARE );
		}
		//Begin Animation chain
		page.out();
	},

	//Reactivate Pointer events when page is finished (called from page.in())
	shown:function(delay){
		app.dispatcher.dispatch( EVENTS.TRACKING_PAGE,page.tracking.current );
		//alert('cPrime');
		$('#js-pg-'+page.tracking.current).addClass('is-ready');
		app.dispatcher.dispatch(EVENTS.PAGE_OPENED, page.tracking);
		//LAUNCHES MESSAGE IN THE STARS

		if( (page.tracking.current === "recieved") || (page.tracking.current === "preview") ) {
			var data = {};
			data.message = app.userMessage;
			app.dispatcher.dispatch( EVENTS.CREATE_MESSAGE_3D,  data );
			
		}
		if(page.tracking.current === "landing") app.uiView.autoCredits();
		//appBar.changePrimary();	
		
	},
	//////////////////////////////////////////////////////
	////ANIMATION CODE
	//////////////////////////////////////////////////////
	out:function() {
		
		app.dispatcher.dispatch(EVENTS.PAGE_CLOSEING, page.tracking);
		
		//Shortcut var to for use of animations
		page.this = '#js-pg-'+page.tracking.previous;
		
		//ANIMATION SWITCH
		switch(page.tracking.previous) {
			case 'preloader':
				ani.preloaderOut.seek(0).play();
			break;
			case 'recieved':
				ani.recieveOut.seek(0).play();
			break;
			case 'landing':
				ani.landingOut.seek(0).play();
			break;
			case 'explore':
				ani.exploreOut.seek(0).play();
			break;
			case 'write':
				ani.writeOut.seek(0).play();
			break;
			case 'preview':
				ani.previewOut.seek(0).play();
			break;
			case 'share':
				ani.shareOut.seek(0).play();
			break;
		}
	},
	
	in:function() {
		
		app.dispatcher.dispatch(EVENTS.PAGE_CLOSED, page.tracking);
		
		app.dispatcher.dispatch(EVENTS.PAGE_OPENING, page.tracking);
		
		//Shortcut var for current page for us in animations
		page.this = '#js-pg-'+page.tracking.current;
		
		//Remove flexbox from previous page
		$('#js-pg-'+page.tracking.previous).removeClass('is-shown');
		
		switch(page.tracking.current) {
			case 'preloader':
				ani.preloaderIn.seek(0).play();
			break;
			case 'recieved':
				ani.recieveIn.seek(0).play();
			break;
			case 'landing':
				ani.landingIn.seek(0).play();
			break;
			case 'explore':
				ani.exploreIn.seek(0).play();
				//alert();
			break;
			case 'write':
				ani.writeIn.seek(0).play();
			break;
			case 'preview':
				ani.previewIn.seek(0).play();
			break;
			case 'share':
				ani.shareIn.seek(0).play();
			break;
		}
		
		//Add flexbox to new page
		$(page.this).addClass('is-shown');
		
		
	}

};